import React from "react";
import { useDispatch, useSelector } from "react-redux";

import InstantQuote from "pu-react/components/InstantQuoteFC";
import Quantities from "pu-react/components/Quantities";
import BomLineItems from "pu-react/components/BomLineItems";
import SmtPlacements from "pu-react/components/SmtPlacements";
import ThruHolePlacements from "pu-react/components/ThruHolePlacements";
import BgaPlacements from "pu-react/components/BgaPlacements";
import QfnPlacements from "pu-react/components/QfnPlacements";
import DoubleSideSMT from "pu-react/components/DoubleSideSMT";
import LeadFreeProcessing from "pu-react/components/LeadFreeProcessing";
import Class3Inspection from "pu-react/components/Class3Inspection";

import SupplierSelected from "pu-react/components/SupplierSelected";
import RowSelected from "pu-react/components/RowSelected";
import ColumnSelected from "pu-react/components/ColumnSelected";
import HiddenInput from "pu-react/components/HiddenInput";

import ProductQuoteNumber from "pu-react/components/ProductQuoteNumber";
import CustomQuote from "pu-react/components/CustomQuote";
import RequiredInformation from "pu-react/components/RequiredInformation";

import { selectAssemblyParameters } from "shared/product_tabs/tab_assembly/selector/selector";

import {
  changeParameter,
  doQuote,
  updateValidatorFlag,
  validator,
} from "shared/product_tabs/tab_assembly/assemblySlice";

import { isParameterNameQtyValid } from "pu-utils/validate";
import { changeGlobalParameter } from "product_tabs/actions";

const Parameters = () => {
  const dispatch = useDispatch();
  const { parameters, validatorFlag } = useSelector(selectAssemblyParameters);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
    if (isParameterNameQtyValid(name))
      dispatch(changeGlobalParameter({ name: `assembly_${name}`, value }));
  };

  const props = {
    parameters,
    onChangeParameter,
  };

  const onQuoteRequest = () => {
    if (validator.allValid()) {
      validator.showMessages();
      dispatch(doQuote());
    } else {
      validator.showMessages();
      dispatch(updateValidatorFlag());
    }
  };

  return (
    <div className="pcb-form-section">
      <div className="row">
        <div className="col-md-6 instant-quote-top">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>
        <div className="col-md-6" />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Quantities
            {...props}
            errorMessage={validator.message(
              "Quantity",
              parameters.quantities,
              "group_required|group_numeric|group_min:1,num"
            )}
          />
        </div>
        <div className="col-md-6">
          <BomLineItems
            {...props}
            errorMessage={validator.message(
              "Bom Line Items",
              parameters.bom_line_items,
              "required|numeric|min:0,num"
            )}
          />
        </div>
        <div className="col-md-6" />
        <div className="col-md-6">
          <SmtPlacements
            inputClassName="assembly-placements"
            {...props}
            errorMessage={validator.message(
              "SMT Placements",
              parameters.smt,
              "required|numeric|min:0,num"
            )}
          />
        </div>
        <div className="col-md-6">
          <ThruHolePlacements
            inputClassName="assembly-placements"
            {...props}
            errorMessage={validator.message(
              "Thru-Hole Placements",
              parameters.thru_hole,
              "required|numeric|min:0,num"
            )}
          />
        </div>
        <div className="col-md-6">
          <BgaPlacements
            inputClassName="assembly-placements"
            {...props}
            errorMessage={validator.message(
              "BGA Placements",
              parameters.bga,
              "required|numeric|min:0,num"
            )}
          />
        </div>
        <div className="col-md-6">
          <QfnPlacements
            inputClassName="assembly-placements"
            {...props}
            errorMessage={validator.message(
              "QFN Placements",
              parameters.qfn,
              "required|numeric|min:0,num"
            )}
          />
        </div>
        <div className="col-md-12">
          <LeadFreeProcessing {...props} />
        </div>
        <div className="col-md-12">
          <DoubleSideSMT {...props} />
        </div>
        <div className="col-md-12">
          <Class3Inspection {...props} />
        </div>

        <div>
          <RowSelected {...props} />
          <ColumnSelected {...props} />
          <SupplierSelected {...props} />
          <ProductQuoteNumber {...props} />
          <input type="hidden" name="quantity" value="1" />
          <HiddenInput name="fine_pitch" value="0" />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <RequiredInformation />
        </div>
        <div className="col-md-6">
          <InstantQuote {...props} onQuoteRequest={onQuoteRequest} />
        </div>
      </div>
      <CustomQuote label="">
        <div className="col-md-12">
          If you are not able to get an online quote you can request a &nbsp;
          <a className="link" href={Spree.routes.custom_quote_request_new_url}>
            custom quote
          </a>
          . You can also email us your BOM and Gerber files to &nbsp;
          <a href="mailto:support@pcbunlimited.com">support@pcbunlimited.com</a>
          .
        </div>
      </CustomQuote>
    </div>
  );
};

export default Parameters;
